export { shortenAddress } from '../utils.js';
export * from './raffle.js';
export * from './sponsor.js';
export * from './squash.js';
export * from './leaderboard.js';
export * from './zod.js';
export * from '../router/games/mysteryCity/types.js';
export * from './arcadeStore.js';
export * from './countries.js';
export * from './quests.js';
export var ClientType;
(function (ClientType) {
    ClientType["IOS"] = "ios";
    ClientType["Android"] = "android";
    ClientType["Extension"] = "extension";
})(ClientType || (ClientType = {}));
export const amountSuffixes = [
    'i8',
    'i16',
    'i32',
    'i64',
    'i128',
    'u8',
    'u16',
    'u32',
    'u64',
    'u128',
];
/// todo - want to properly format but this is breaking extension send/receive detail pages
// const formatter = new Intl.NumberFormat('en-US', {
//   maximumFractionDigits: 2,
//   useGrouping: true
// });
/// converting, for example, "50000000u64" to 50
export const rawCreditsToDisplay = (raw) => {
    const amount = extractAmountFromInputString(raw);
    return amount ? amount / 1_000_000 : null;
};
/// converting, for example, "50000000u64" to "50.000000"
export const rawCreditsToFormatted = (raw) => {
    const amount = extractAmountFromInputString(raw);
    if (amount === null)
        return null;
    const credits = amount / 1_000_000;
    const whole = Math.floor(credits);
    const fractional = (credits % 1).toFixed(6).slice(2);
    const formattedWhole = whole.toLocaleString('en-US');
    return `${formattedWhole}.${fractional}`;
};
export const removeVisibilitySuffix = (input) => {
    if (typeof input !== 'string') {
        return null;
    }
    return input.replaceAll('.private', '').replaceAll('.public', '');
};
/// extracting numeric value from "50000000u64" or "50000000u64.private"
export const extractAmountFromInputString = (input) => {
    if (typeof input !== 'string') {
        return null;
    }
    const regex = /(\d+)(i8|i16|i32|i64|i128|u8|u16|u32|u64|u128)(\.private)?$/;
    const match = input.match(regex);
    if (!match) {
        // DO NOT CHANGE TO "logger" HERE
        // Extension will get bricked bc it cannot use the logger.
        console.error(`(extractAmountFromInputString) input (${input}) is not a valid amount`);
        return null;
    }
    return Number(match[1]);
};
export const displayAmountToMicrocredits = (input) => {
    return `${Math.floor(input * 1_000_000)}u64`;
};
export const displayAmountToU128 = (input, decimals) => {
    return `${Math.floor(input * Math.pow(10, decimals))}u128`;
};
export var StatusColor;
(function (StatusColor) {
    StatusColor["green"] = "green";
    StatusColor["yellow"] = "yellow";
    StatusColor["red"] = "red";
    StatusColor["blue"] = "blue";
    StatusColor["gray"] = "gray";
})(StatusColor || (StatusColor = {}));
